import React from "react";
import { useNavigate } from 'react-router-dom';
import { ROUTER_DIAGRAMS, ROUTER_INDEX, ROUTER_INDEX_PAGE, ROUTER_TEMPLATE_LIST } from "@/entry/route";
import { goLogin } from "@/utils/login";
import logo from '@/assets/logo.png'
import config from 'config'
import classNames from "classnames";
import { useTranslation } from 'react-i18next';

type NavProps = {
  isLogin: boolean
  loading: boolean
  className?: string
}

export const Navbar = (props: NavProps) => {
  const { t } = useTranslation('app');

  const navigate = useNavigate()

  const renderAction = () => {
    if (props.isLogin) {
      return <span onClick={() => navigate(ROUTER_INDEX_PAGE)}>{t('pages.welcome.nav.my_space')}</span>
    }
    return <span onClick={goLogin}>{t('pages.welcome.nav.login')}</span>
  }

  return (
    <nav id="header" className={classNames("fixed w-full z-30 top-0 text-white", props.className)}>
      <div className="w-full container mx-auto flex flex-wrap items-center justify-between mt-0 py-1">
        <div className="pl-4 flex items-center">
          <a 
            className="flex items-center space-x-2 text-black no-underline hover:no-underline font-semibold text-lg lg:text-xl cursor-pointer" 
            href="/"
          >
            <img 
              src={logo} 
              alt="logo" 
              className="h-6 lg:h-8 inline" 
            />
            <span>{config.product}</span>
          </a>
        </div>
        <div className="block lg:hidden pr-4">
          <button id="nav-toggle" className="flex items-center p-1 text-pink-800 hover:text-gray-900 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out">
            <svg className="fill-current h-6 w-6" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div className="w-full flex-grow lg:flex lg:items-center lg:w-auto hidden mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20" id="nav-content">
          <ul className="list-reset lg:flex justify-end flex-1 items-center">
            <li className="mr-3">
              <a className="inline-block py-2 px-4 text-black font-bold no-underline" href={ROUTER_TEMPLATE_LIST}>{t('layout.sider.template')}</a>
            </li>
            <li className="mr-3">
              <a className="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4" href="/help_center">{t('layout.header.help_center')}</a>
            </li>
            {/* <li className="mr-3">
              <a className="inline-block text-black no-underline hover:text-gray-800 hover:text-underline py-2 px-4" href="/blogs">博客</a>
            </li> */}
          </ul>
          {!props.loading && <button
            id="navAction"
            className="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-full mt-4 lg:mt-0 py-2 px-8 shadow opacity-95 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
          >
            {renderAction()}
          </button>}
        </div>
      </div>
      <hr className="border-b border-gray-100 opacity-25 my-0 py-0" />
    </nav>
  )
}
